/**
 * Flag "tiltímetro sem sinal" para o banner do Header — GUPM-158.
 *
 * STUB até a rodada de Instrumentação: a fonte real (tiltímetros sem
 * comunicação) virá do datasource `instrumentacao` (TetraTech). Espelha o
 * `TILT_SIGNAL_LOST` do protótipo v5.10. Retorna `false` por ora (sem banner).
 *
 * Encaixe: quando a fonte real existir, trocar só este hook — o
 * `TiltLostBanner` (puro, orientado a props) não muda.
 */
export function useTiltSignalLost(): boolean {
  return false;
}
